import { jsx as i } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { convertAttributesInElement as f } from "./utils.mjs";
import { useStoryblokRichText as s } from "./richtext.mjs";
const h = c(
  ({ doc: t, resolvers: r }, o) => {
    const { render: e } = s({
      resolvers: r
    }), m = e(t), n = f(m);
    return /* @__PURE__ */ i("div", { ref: o, children: n });
  }
);
export {
  h as default
};
